export default __webpack_public_path__ + "static/media/DataResource.3a8ed2ee.svg";